import CryptoJS from "crypto-js"; // Ensure CryptoJS is installed

export default {
  data() {
    return {
      DB_NAME: "UserDB",
      DB_VERSION: 1,
      USER_STORE: "users",
      SECRET_KEY: "my_secret_key", // Use a secure key
    };
  },
  methods: {
    // Open IndexedDB
    openDB() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(this.DB_NAME, this.DB_VERSION);

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains(this.USER_STORE)) {
            db.createObjectStore(this.USER_STORE, { keyPath: "user" });
          }
        };

        request.onsuccess = (event) => resolve(event.target.result);
        request.onerror = (event) => {
          console.error("IndexedDB error:", event.target.error);
          reject(event.target.error);
        };
      });
    },

    // Encrypt Data
    encryptData(data) {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.SECRET_KEY).toString();
    },

    // Decrypt Data
    decryptData(encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    },

    // **ADD USER (Avoid Duplicate)**
    async saveUser(user, accountType, password) {
      const db = await this.openDB();
      const existingUser = await this.getUser(user);

      if (existingUser) {
        console.warn(`User "${user}" already exists. Skipping add.`);
        return false;
      }

      const encrypted = this.encryptData({ accountType, password });

      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.USER_STORE, "readwrite");
        const store = tx.objectStore(this.USER_STORE);
        const request = store.add({ user, encrypted });

        request.onsuccess = () => {
          console.log(`User "${user}" added successfully.`);
          resolve(true);
        };
        request.onerror = (event) => {
          console.error("Error adding user:", event.target.error);
          reject(event.target.error);
        };
      });
    },

    // **GET USER**
    async getUser(user) {
      const db = await this.openDB();

      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.USER_STORE, "readonly");
        const store = tx.objectStore(this.USER_STORE);
        const request = store.get(user);

        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(event.target.error);
      });
    },

    // **LIST ALL USERS (REVERSED ORDER)**
    async getAllUsers() {
      const db = await this.openDB();

      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.USER_STORE, "readonly");
        const store = tx.objectStore(this.USER_STORE);
        const request = store.getAll();

        request.onsuccess = () => {
          const users = request.result
            .map(userObj => ({
              user: userObj.user,
              decrypted: this.decryptData(userObj.encrypted),
            }))
            .reverse(); // Reverse the order
          resolve(users);
        };
        request.onerror = () => reject(event.target.error);
      });
    },

    // **REMOVE USER**
    async removeUser(user) {
      const db = await this.openDB();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.USER_STORE, "readwrite");
        const store = tx.objectStore(this.USER_STORE);
        const request = store.delete(user);
    
        request.onsuccess = async () => {
          console.log(`User "${user}" removed.`);
          const updatedUsers = await this.getAllUsers(); // Get updated list
          resolve(updatedUsers);
        };
    
        request.onerror = () => reject(event.target.error);
      }).finally(() => {
        this.show_dropdown = false; // Close the popup in the final block
      });
    }    
  }
};



// WEBPACK FOOTER //
// ./src/store/userDB.js